import React from 'react';
import { Callout, ConfirmationModal, Typography } from 'seagull';
import ExternalLinkButton from "../ExternalLinkButton";
import styles from "./ConfirmExternallySignModal.module.scss";
import { helpArticles } from "../../utils/helpArticles";
export default function ConfirmExternallySignModal(props) {
  const {
    bulkData,
    hasBilledImmediatelyService,
    dismissModal
  } = props;
  const hasMultipleClients = !!bulkData && bulkData.numClients > 1;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: bulkData ? 'Approve on behalf of clients in bulk' : 'Approve on behalf of the client',
    textAlignCenter: false,
    width: "750px",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.confirmExternallySigned
    }, /*#__PURE__*/React.createElement(Typography, null, "By approving this action on behalf of your client, you represent and warrant that you have obtained full and valid authorization from", hasMultipleClients ? " these ".concat(bulkData.numClients, " clients") : ' the client', " and assume all responsibility for billing them in accordance with the terms, conditions, and provisions of the agreement created on Anchor."), /*#__PURE__*/React.createElement(Typography, null, "Note the following:"), /*#__PURE__*/React.createElement(Typography, {
      as: "ul"
    }, ["The approved agreement will not include the client's digital signature.", "Invoices will be issued according to the agreement terms but will only be processed after a payment method is added by you or the client.", "The client will not be notified of this action; however, any future notifications related to this agreement will be sent to the client based on your notification settings."].map((text, idx) => /*#__PURE__*/React.createElement("li", {
      key: idx,
      className: styles.bullet
    }, /*#__PURE__*/React.createElement("span", null), text))), /*#__PURE__*/React.createElement(Callout, null, /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: helpArticles.onboardingExistingClients()
    }, "Learn more"), ' ', "about best practices for transitioning existing clients to Anchor."), hasBilledImmediatelyService && /*#__PURE__*/React.createElement(Callout, {
      intent: "warning",
      "data-testid": "immediately-issued-warning"
    }, "As this proposal includes a service that is set to be billed upon acceptance, an invoice will be issued immediately.")),
    primaryButtonLabel: hasMultipleClients ? 'Approve on behalf of clients' : 'Approve on behalf of the client',
    primaryButtonTestid: "confirm-externally-sign",
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "cancel-externally-sign",
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}